<template>
  <div>
    <ul class="products-grid">
      <li class="searchProduct border border-balternative-color rounded">
        <a class="searchProduct__link" href="" @click.prevent="goToProductDetailPage">
          <div v-if="searchProduct.originalProductId !== null && searchProduct.productRelationType === 'Followup'">
            <div>
              <Alert :html="true" type="info" :htmlMessage="searchProduct.originalProductMessage"></Alert>
            </div>
          </div>
          <div class="searchProduct__img-wrapper relative">
            <div v-if="searchProduct.isMobProduct" class="absolute top-0 left-0">
              <span class="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600">
                Mediq Alternatief
              </span>
            </div>
            <img :src="searchProduct.imageUrl" @error="handleImageError" class="absolute" />
            <component
              :is="getEnumValue(favoriteStatusEnum, String(searchProduct.isFavourite))"
              class="cursor-pointer searchProduct__favoriteStatus"
              @click.prevent="addToFavorite($event, searchProduct.productId, searchProduct.baseProductId)"
            />
          </div>
          <div class="searchProduct__text col">
            <strong class="searchProduct__text__name">{{ $toTitleCase(searchProduct.title) }}</strong>
            <br />
            <strong class="searchProduct__text__manufacturer">
              Fabrikant: {{ $toTitleCase(searchProduct.manufName) }}
              <span>Artikelcode: {{ searchProduct.productCode }}</span>
              <span> Verpakking: {{ searchProduct.packagingUnit }} {{ searchProduct.packagingLabel }}</span>
            </strong>
          </div>
          <button
            v-if="searchProduct.alternativesProduct !== null && !searchProduct.orderable && !isAssortmentFlow"
            class="bg-primary-default flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full items-center mb-2 mr-2"
            @click.prevent="showAlternateProducts($event)"
          >
            {{ getButtonText }}
          </button>
          <button
            v-else-if="!searchProduct.orderable && !isAssortmentFlow && searchProduct.materialStatusCode == 30"
            class="bg-primary-default flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full items-center mb-2 mr-2"
            @click.prevent="orderSearchProduct"
          >
            Op bestelling verkrijgbaar
          </button>
          <div class="mb-2" v-else-if="!searchProduct.orderable && !isAssortmentFlow">Niet bestelbaar</div>
          <button
            v-else-if="!isAssortmentFlow && searchProduct.orderable"
            class="bg-primary-default flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-cta rounded-full items-center mb-2 mr-2"
            @click.prevent="orderSearchProduct"
          >
            Bestellen
          </button>
        </a>
      </li>
    </ul>
    <v-overlay v-if="showProductFavourites" class="search-product-overlay">
      <v-product-favourites
        :base-product="selectedBaseProductForFavorite"
        :product="selectedProductForFavorite"
        :product-id="productId"
        @success="successSaveFavorite(...arguments)"
        @cancel="closeOverlay"
      />
    </v-overlay>
    <!--Pop up to show alternative products -->
    <generic-modal
      v-if="showAlternateProductPopUp"
      :has-close-button="true"
      :modal-Medium-Width="true"
      @close="closeAlternateProductModal"
    >
      <template #header>
        <div v-if="productRelationType == 'Followup'" class="mb-4">Opvolgend product</div>
        <div v-if="productRelationType == 'Substitute'" class="mb-4">Vervangend product</div>
        <div v-else-if="productRelationType == 'Alternatives'" class="mb-4">Alternatief product</div>
      </template>
      <template #body>
        <div class="mb-4">
          <Alert :html="true" :htmlMessage="alternativeProductHtmlMsg" type="info"></Alert>
        </div>
        <div class="relative mb-4">
          <div class="grid sm:grid-rows-4 md:grid-cols-2 lg:grid-cols-2 gap-2 mb-4">
            <card
              v-for="item in alternateCards"
              :key="item.id"
              class="border border-disabled-background h-full flex flex-col"
              :customClass="[item.originalProductId === null ? 'bg-gray-200' : null]"
            >
              <template v-slot>
                <div class="flex flex-col flex-grow -mt-6">
                  <div class="flex items-center justify-center my-2 h-28 w-full flex-shrink-0">
                    <img
                      :src="getImageUrl(item.imageUrl)"
                      @error="handleImageError"
                      class="mx-auto max-h-full max-w-full cursor-pointer"
                      @click.prevent="goToProductDetailPageFromPopup(item.baseProductId)"
                    />
                  </div>
                  <div
                    class="text-tdefault-color font-semibold text-xs mb-1 h-14 overflow-hidden cursor-pointer"
                    @click.prevent="goToProductDetailPageFromPopup(item.baseProductId)"
                  >
                    {{ item.title }}
                  </div>
                  <div class="text-talternative-color text-sm mb-4">
                    {{ item.packagingUnit }} {{ item.packagingLabel }} per verpakking
                  </div>
                </div>
                <div class="mt-auto">
                  <div class="grid grid-cols-2 gap-2 mb-3">
                    <div class="flex items-center text-sm">
                      <span
                        class="inline-flex items-center gap-1 border-b border-dashed px-1"
                        :class="item.orderable ? '' : 'text-warning-default border-warning-default'"
                      >
                        <component :is="item.orderable ? '' : 'XCircleIcon'" class="h-5 w-5" />
                        {{ item.orderable ? '' : 'Niet leverbaar' }}
                      </span>
                    </div>
                    <div class="flex items-center text-sm">
                      <span
                        class="inline-flex items-center gap-1 border-b border-dashed px-1"
                        :class="
                          item.insured
                            ? 'text-success-default border-success-default'
                            : 'text-danger-text border-danger-text'
                        "
                      >
                        <component :is="item.insured ? 'CheckCircleIcon' : 'ExclamationCircleIcon'" class="h-5 w-5" />
                        {{ item.insured ? 'Vergoed' : 'Niet vergoed' }}
                      </span>
                    </div>
                  </div>

                  <div v-if="item.originalProductId !== null" class="grid grid-cols-2 gap-6">
                    <div class="border border-gray-400 rounded-md h-8 mt-1">
                      <MinusIcon
                        class="text-pdsPrimaryColor float-left w-8 border-r border-gray-400 cursor-pointer mr-1"
                        aria-hidden="true"
                        @click.prevent="reduceQuantity(item)"
                      />
                      <input
                        class="max-w-12 h-7 font-bold pt-1 align-middle text-center pl-3"
                        v-model="currentQuantity"
                        type="number"
                        min="1"
                        max="999"
                        maxlength="3"
                        autocomplete="off"
                        @change="saveProductQuantity(currentQuantity, item)"
                      />
                      <PlusIcon
                        class="text-pdsPrimaryColor float-right w-8 border-l border-gray-400 cursor-pointer ml-1"
                        aria-hidden="true"
                        @click.prevent="increaseQuantity(item)"
                      />
                    </div>
                    <div class="flex items-center text-sm">
                      <button
                        class="flex justify-center pl-5 pr-5 text-white text-xs md:text-base font-medium items-center bg-primary-default border border-primary-default rounded-full p-2"
                        @click.prevent="orderAlternateProduct(item)"
                      >
                        Bestellen
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </card>
          </div>
          <div
            class="absolute w-full top-32 z-50"
            v-if="recentAlternateProducts.length != 0 && alternateCards.length > 0"
          >
            <div
              class="flex mb-4"
              :class="[
                (showAlternateNext && showAlternatePrev) || (showAlternatePrev && !showAlternateNext)
                  ? 'justify-between items-center'
                  : 'justify-end'
              ]"
            >
              <button
                v-if="showAlternatePrev"
                @click="alternatePrev"
                :class="{ hidden: alternateSlideIndex === 0 }"
                class="rounded-full bg-primary-default border border-primary-default -ml-4"
              >
                <ChevronLeftIcon class="h-8 w-8 inline-block text-white" aria-hidden="true" />
              </button>
              <button
                v-if="showAlternateNext"
                @click="alternateNext"
                :class="{ hidden: alternateSlideIndex + alternatesPerPage >= recentAlternateProducts.length }"
                class="rounded-full bg-primary-default border border-primary-default -mr-4"
              >
                <ChevronRightIcon class="h-8 w-3 w-8 inline-block text-white" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </template>
      <template #footer> </template>
    </generic-modal>
  </div>
</template>

<script>
import router from '@/router';
import { shoppingCart$, addToShoppingCart, activePpwRecId$, getBaseProductDetailsByProductId } from '@/services';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import VHeartIcon from 'icons/Heart';
import VHeartOutlineIcon from 'icons/HeartOutline';
import VProductFavourites from '@/components/sections/catalog/productDetail/ProductFavourites';
import GenericModal from '@/components/shared/GenericModal';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/vue/20/solid';
import { CheckCircleIcon, ExclamationCircleIcon, XCircleIcon, HeartIcon } from '@heroicons/vue/24/outline';
import { PlusIcon, MinusIcon } from '@heroicons/vue/20/solid';

export default {
  name: 'VSearchProduct',
  components: {
    VHeartIcon,
    VHeartOutlineIcon,
    VProductFavourites,
    GenericModal,
    ChevronRightIcon,
    ChevronLeftIcon,
    CheckCircleIcon,
    ExclamationCircleIcon,
    XCircleIcon,
    HeartIcon,
    PlusIcon,
    MinusIcon
  },
  props: {
    searchProduct: {
      type: Object,
      required: true
    }
  },
  setup() {
    const store = useStore();
    const patientId = store.state.patient.patientGegevens.PatientId;
    const shoppingCart = ref(null);
    const activePpwRecId = ref(null);

    const setOrderClicked = (value) => store.commit('cart/setOrderClicked', value);

    shoppingCart$.subscribe((cart) => {
      shoppingCart.value = cart;
    });

    activePpwRecId$.subscribe((id) => {
      activePpwRecId.value = id;
    });

    return {
      patientId,
      setOrderClicked,
      shoppingCart,
      activePpwRecId
    };
  },
  data() {
    return {
      baseProduct: true,
      count: 1,
      favoriteStatusEnum: {
        false: 'v-heart-outline-icon',
        true: 'v-heart-icon'
      },
      baseProductDetail: null,
      productDetails: null,
      selectedProductForFavorite: null,
      selectedBaseProductForFavorite: null,
      showProductFavourites: false,
      productId: null,
      alternatePages: 0,
      alternatesPerPage: 2,
      alternateCards: null,
      alternateSlideIndex: 0,
      showAlternatePrev: false,
      showAlternateNext: false,
      showAlternateProductPopUp: false,
      productRelationType: '',
      alternativeProductHtmlMsg:
        '<b>Onze product specialisten raden dit alternatieve product aan </b> </br> Dit product is niet te bestellen. Onze product specialisten hebben voor u een alternatief product geselecteerd.',
      recentAlternateProducts: null,
      currentQuantity: 1
    };
  },
  computed: {
    isReplenishmentFlow() {
      return router.currentRoute.value.meta.flow === 'replenishment';
    },
    isAssortmentFlow() {
      return router.currentRoute.value.meta.flow === 'assortment';
    },
    isCustomerFlow() {
      return router.currentRoute.value.meta.flow === 'customer';
    },
    getButtonText() {
      switch (this.searchProduct.alternativesProduct.productRelationType) {
        case 'Followup':
          return 'Bekijk opvolgend product';
        case 'Substitute':
          return 'Bekijk vervangend product';
        case 'Alternatives':
          return 'Bekijk alternatieve product';
        default:
          return '';
      }
    }
  },
  methods: {
    /**
     * @function getEnumValue
     * @param {object} - enum list
     * @param {string} - enum key
     * @returns {any} - value that matches the key
     */
    getEnumValue(enumList, enumKey) {
      if (enumKey === 'null' || enumKey === '') {
        return enumList.false;
      }
      for (const key in enumList) {
        if (enumList.hasOwnProperty(key)) {
          if (key === enumKey) {
            return enumList[key];
          }
        }
      }
    },
    imageLoadError() {
      console.warn('No product image');
    },
    goToProductDetailPage() {
      if (this.isCustomerFlow) {
        router.push('/catalog/baseProduct/' + this.searchProduct.baseProductId);
      }
      if (this.isReplenishmentFlow) {
        router.push('/aanvullenmagazijn/product/' + this.searchProduct.productId);
      }
      if (this.isAssortmentFlow) {
        router.push('/assortiment/baseProduct/' + this.searchProduct.baseProductId);
      }
    },
    showAlert() {
      this.$emitter.emit('notification', {
        title: `${this.searchProduct.title} is toegevoegd.`,
        htmlMessage: `<p class="underline cursor text-gray-900" data-route="/bestellijst">Bestelling afronden</p>`
      });
    },
    orderSearchProduct(e) {
      e.stopPropagation();
      this.setOrderClicked(true);
      let order = this.searchProduct;
      if (order) {
        order.addedToBasket = true;
        order.count = this.count;
        addToShoppingCart(
          this.shoppingCart,
          this.searchProduct.productId,
          this.count,
          this.activePpwRecId,
          this.searchProduct.isConsignmentProduct
        );
        this.showAlert(this.searchProduct.productId);
      }
    },
    orderAlternateProduct(alternateProduct) {
      this.setOrderClicked(true);
      let order = alternateProduct;
      JSON.stringify('alternateProduct: ' + JSON.stringify(order));
      this.showAlternateProductPopUp = false;
      if (order) {
        order.addedToBasket = true;
        order.count = this.currentQuantity;
        addToShoppingCart(
          this.shoppingCart,
          alternateProduct.productId,
          this.currentQuantity,
          this.activePpwRecId,
          alternateProduct.isConsignmentProduct
        );
        this.showAlert(alternateProduct.productId);
      }
    },
    addToFavorite(e, productId, baseProductId) {
      e.stopPropagation();

      getBaseProductDetailsByProductId(productId, this.isCustomerFlow, false).then((r) => {
        this.baseProductDetail = r;
        this.productDetails = r.products.filter((obj) => {
          return obj.productId === productId;
        });

        this.selectedProductForFavorite = this.productDetails[0];
        this.selectedBaseProductForFavorite = this.baseProductDetail;
        this.productId = productId;
        this.showProductFavourites = true;
      });
    },
    successSaveFavorite(isAdded) {
      this.selectedProductForFavorite = null;
      this.selectedBaseProductForFavorite = null;
      this.productId = null;
      this.closeOverlay();
      this.$emit('favoriteAdded');
    },
    closeOverlay() {
      this.showProductFavourites = false;
    },
    resetAlternateIndex() {
      this.alternateSlideIndex = 0;
    },
    showAlternateProducts(e) {
      e.stopPropagation();
      this.productRelationType = this.searchProduct.alternativesProduct.productRelationType;
      var alternativeProductModel = [];
      this.currentQuantity = 1;

      alternativeProductModel.push(this.searchProduct.alternativesProduct);
      alternativeProductModel.push(this.searchProduct);

      if (this.productRelationType === 'Followup') {
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatieve', 'opvolgende');
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatief', 'opvolgend');
      } else if (this.productRelationType === 'Substitute') {
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatieve', 'vervangende');
        this.alternativeProductHtmlMsg = this.alternativeProductHtmlMsg.replaceAll('alternatief', 'vervangend');
      }

      this.recentAlternateProducts = computed(() => {
        const computedAlternateProducts = Array.isArray(alternativeProductModel) ? alternativeProductModel : [];
        const firstProduct = computedAlternateProducts[0]?.ProductId;

        const result = computedAlternateProducts.map((item) => ({
          ...item,
          showLabel: item.ProductId === firstProduct
        }));
        // Slice if filterCount is present
        return result;
      });

      this.alternatePages = computed(() => {
        return Math.ceil(this.recentAlternateProducts.length / this.alternatesPerPage);
      });

      this.alternateCards = computed(() => {
        let start = this.alternateSlideIndex * this.alternatesPerPage;
        let end = start + this.alternatesPerPage;
        if (start > this.recentAlternateProducts?.length) {
          this.resetAlternateIndex();
          start = 0;
          end = 2;
        }
        return this.recentAlternateProducts ? this.recentAlternateProducts.slice(start, end) : [];
      });

      this.showAlternatePrev = computed(() => this.alternateSlideIndex > 0);
      this.showAlternateNext = computed(() => this.alternateSlideIndex < this.alternatePages - 1);

      this.showAlternateProductPopUp = true;
    },
    closeAlternateProductModal() {
      this.showAlternateProductPopUp = false;
      this.currentQuantity = 0;
      this.alternateSlideIndex = 0;
    },
    reduceQuantity(item) {
      if (this.currentQuantity === 1) {
        return;
      }
      this.saveProductQuantity(this.currentQuantity - 1, item);
    },
    increaseQuantity(item) {
      if (this.currentQuantity === 999) {
        return;
      }
      this.saveProductQuantity(this.currentQuantity + 1, item);
    },
    saveProductQuantity(inputValue, item) {
      let regex = /^[0-9]{1,3}$/;
      let quantity = parseInt(inputValue, 10);
      if (quantity <= 0) {
        quantity = 1;
      }
      if (quantity > 999) {
        quantity = 999;
      }
      if (!regex.test(quantity) || !quantity || quantity <= 0) {
        this.currentQuantity = 0;
        return;
      }
      this.currentQuantity = quantity;
    },
    goToProductDetailPageFromPopup(baseProductId) {
      router.push('/catalog/baseProduct/' + baseProductId);
    }
  }
};
</script>
<style land="css">
.search-product-overlay > div {
  overflow-y: auto;
  max-height: 500px;
  min-width: 800px;
  padding: 2rem !important;
}
</style>
<style lang="scss" scoped>
.products-grid {
  height: 100%;
}
.searchProduct__img-wrapper {
  height: 100px; // hardcoded due to bad quality images and tryig to invoke a standard height display in the grid.
}
.searchProduct {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: $white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  border-radius: 8px;
  box-sizing: border-box;
  height: 100%;

  &__link {
    text-decoration: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  &__img-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    margin-bottom: 16px;
    height: 100px;

    img {
      max-height: 100px;
      max-width: 100px;
      object-fit: contain;
    }
  }

  &__text {
    text-align: center;
    margin-bottom: 16px;

    &__name {
      color: $gray-darkest;
      font-weight: bold;
      font-size: 1.1em;
      margin: 0;
      margin-bottom: 8px;
    }

    &__manufacturer {
      font-size: 0.9em;
      font-weight: normal;
      line-height: normal;
      color: $gray-dark;
      margin: 0;

      span {
        display: block;
        margin-top: 4px;
      }
    }
  }

  &__noordertext {
    color: $gray-darkest;
    text-align: center;
    margin-top: 8px;
  }

  &__favoriteStatus {
    fill: #006983 !important;
    width: 2rem !important;
    position: absolute !important;
    left: 88%;
    bottom: 65%;
  }

  v-button {
    width: 100%;
  }
}
</style>
